import React from 'react';
import { Typography } from '@mui/material';

const MobilityRequests = () => (
  <Typography variant="h2">MobilityRequests</Typography>
);

export default MobilityRequests;
